import { render } from "./InvestmentSummary.vue?vue&type=template&id=8f0bed14&scoped=true"
import script from "./InvestmentSummary.vue?vue&type=script&lang=js"
export * from "./InvestmentSummary.vue?vue&type=script&lang=js"

import "./InvestmentSummary.vue?vue&type=style&index=0&id=8f0bed14&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0bed14"]])

export default __exports__